import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, useFormState } from 'react-final-form';
import KeySkillItems from '../../components/KeySkillItems';
import { getKeySkillSuggestions } from '../../actions/app';
import FieldError from '../../components/FieldError';
import InputSuggestion from '../../components/InputSuggestion';


const MAX_KEY_SKILL_LENGTH = 64;
const DELETE_ANIMATION_MS = 800;

const RenderSkillKeys = ({ fields }) => {
  const form = useForm();
  const { values } = useFormState({ subscription: { values: true } });
  const keySkillValue = values.key_skill || '';
  const skills = values.keySkills || [];

  const currentTimerId = useRef(null);
  const skillsToDelete = useRef([]);
  const [keySkillErrors, setKeySkillErrors] = useState({
    alreadyExist: false,
    lengthOversize: false,
  });

  const onKeySkillAdd = () => {
    if (skills.map(({ value }) => value).includes(keySkillValue)) {
      setKeySkillErrors({ alreadyExist: true, lengthOversize: false });
    } else if (keySkillValue.length > MAX_KEY_SKILL_LENGTH) {
      setKeySkillErrors({ alreadyExist: false, lengthOversize: true });
    } else {
      fields.push({ value: keySkillValue });
      form.change('key_skill', '');
      setKeySkillErrors({ alreadyExist: false, lengthOversize: false });
    }
  };

  // Several skills clicked in a row are removed together after the animation.
  const onKeySkillDelete = (index) => {
    skillsToDelete.current = [...skillsToDelete.current, index];

    if (currentTimerId.current) {
      clearTimeout(currentTimerId.current);
    }

    currentTimerId.current = setTimeout(() => {
      const modSkillsToDelete = [...skillsToDelete.current].sort((x, y) => y - x);
      modSkillsToDelete.forEach((indexToDelete) => {
        fields.remove(indexToDelete);
      });
      skillsToDelete.current = [];
      currentTimerId.current = null;
    }, DELETE_ANIMATION_MS);
  };

  return (
    <div className="mb-5">
      <KeySkillItems skills={skills} onKeySkillDelete={onKeySkillDelete} />
      <div className="key-skill-input-wrapper">
        <InputSuggestion
          name="key_skill"
          type="text"
          label="Навык"
          placeholder="Например 'пунктуальность'"
          value={keySkillValue}
          getSuggestions={getKeySkillSuggestions}
          classNames="key-skill-input"
        />
        <button
          type="button"
          disabled={!keySkillValue}
          className="button button_plus key-skill-add-button"
          onClick={onKeySkillAdd}
        >
          <span className="button-icon">+</span>
          <span className="button-text">Добавить навык</span>
        </button>
        {keySkillErrors.alreadyExist && <FieldError error="Данный навык уже был добавлен" />}
        {keySkillErrors.lengthOversize && <FieldError error="Навык превышает длинну в 64 символа" />}
      </div>
    </div>
  );
};

RenderSkillKeys.propTypes = {
  fields: PropTypes.object.isRequired,
};

export default RenderSkillKeys;
